import UpdateAgendaItemData from "@/domain/entities/agenda/UpdateAgendaItemData";
import { queryKeys } from "@/lib/queryKeys";
import updateAgendaItemDataMapper from "@/mappers/agenda/updateAgendaItemDataMapper";
import { useAgenda } from "@cs_teamwaydev/mailvista-sdk_react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import useErrorToast from "../utils/useErrorToast";

const useUpdateAgendaEvent = (onSuccess?: () => void) => {
    const agenda = useAgenda();
    const showError = useErrorToast();
    const queryClient = useQueryClient();

    const updateAgendaEvent = useMutation<
        void,
        unknown,
        { agendaItemId: string; updateAgendaItemData: UpdateAgendaItemData }
    >({
        mutationFn: async ({ agendaItemId, updateAgendaItemData }) => {
            const updateDataToSDK =
                updateAgendaItemDataMapper(updateAgendaItemData);

            const updated = await agenda.updateAgendaItem(
                agendaItemId,
                updateDataToSDK,
            );

            if (!updated) {
                throw new Error("Agenda item update refused by the provider");
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: queryKeys.agendaEvents.all(),
            });
            onSuccess?.();
        },
        onError: (error) => {
            console.error(error);
            showError({
                titleTranslationKey: "errors.agenda.update",
            });
        },
    });

    return { updateAgendaEvent };
};

export default useUpdateAgendaEvent;
